import api from "./axios";

// Helper function to extract error message from API response
export const getClientErrorMessage = (error) => {
  if (error && error.response && error.response.data) {
    if (error.response.data.message) {
      return error.response.data.message;
    }
    if (
      error.response.data.errors &&
      Array.isArray(error.response.data.errors)
    ) {
      return error.response.data.errors[0];
    }
    if (
      error.response.data.errors &&
      typeof error.response.data.errors === "object"
    ) {
      const firstError = Object.values(error.response.data.errors)[0];
      if (Array.isArray(firstError)) {
        return firstError[0];
      }
      return String(firstError);
    }
  }
  return error?.message || "An unexpected error occurred";
};

// Clients API service
export const clientsApi = {
  // Get all clients
  getAll: async (status = 1) => {
    try {
      const response = await api.get(`/clients?status=${status}`);
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },

  // Get client by ID
  getById: async (id) => {
    try {
      const response = await api.get(`/clients/${id}`);
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },

  // Create new client
  create: async (clientData) => {
    try {
      const response = await api.post("/clients", clientData);
      return response.data;
    } catch (error) {
      return { error: error.response?.data };
    }
  },

  // Update client details
  updateDetails: async (id, clientData) => {
    try {
      const response = await api.put(`/clients/${id}/details`, clientData);
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },

  // Update client fees
  updateFees: async (id, feesData) => {
    try {
      const response = await api.put(`/clients/${id}/fees`, feesData);
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },
 getConsumerAcknowledgement: async (clientId) => {
  try {
    const response = await api.get(`/consumer/${clientId}/acknowledgement`);
    console.log("✅ Fetched consumer acknowledgement:", response.data);
    return response.data; // { data: ack | null }
  } catch (error) {
    throw error; // ⬅️ IMPORTANT: let axios throw
  }
},


  createOrUpdateConsumerAcknowledgement: async (ClientId, payload) => {
    try {
      const response = await api.post(`/clients/${ClientId}/acknowledgement`, payload);
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },
  updateConsumerAcknowledgement: async (ClientId, payload) => {
    try {
      const response = await api.put(`/clients/${ClientId}/acknowledgement`, payload);
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },
  // Update client web details
  updateWebDetails: async (id, webDetailsData) => {
    try {
      const response = await api.put(
        `/clients/${id}/web-details`,
        webDetailsData
      );
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },

  // Update client credit bundles
  updateCreditBundles: async (id, creditBundles) => {
    try {
      const response = await api.put(
        `/clients/${id}/credit-bundles`,
        creditBundles
      );
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },

  // Get clients dropdown list
  getDropdown: async () => {
    try {
      const response = await api.get("/clients/dropdown");
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },

  // Delete client
  delete: async (id) => {
    try {
      const response = await api.delete(`/clients/${id}`);
      return response.data;
    } catch (error) {
      return { error: getClientErrorMessage(error) };
    }
  },
};

export default clientsApi;
